module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-main-attendees"
  }, [_c('span', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('ul', {
    staticClass: "block-live-profiles"
  }, _vm._l((_vm.attendees), function(attendee) {
    return _c('li', [_c('div', {
      staticClass: "block-profile-image"
    }, [_c('div', {
      staticClass: "block-image-wrapper"
    }, [_c('img', {
      staticClass: "block-image",
      attrs: {
        "src": attendee.PictureUrl,
        "alt": attendee.Name,
        "title": attendee.Name
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "block-profile-content"
    }, [_vm._v(_vm._s(attendee.Name))])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57f235b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Top/TopTextBoxGovernmentAttendees.vue
// module id = 99
// module chunks = 1